const use_s3 = process.env.USE_S3 === '1'
const STATIC_VERSION = process.env.STATIC_VERSION

let statics = '/static'

if (use_s3) {
  if (process.env.AWS_CDN_CUSTOM_DOMAIN) {
    statics = `https://${process.env.AWS_CDN_CUSTOM_DOMAIN}/${process.env.AWS_LOCATION}`
  } else {
    statics = `https://${process.env.AWS_S3_STORAGE_BUCKET_DOMAIN}/${process.env.AWS_LOCATION}`
  }
}

export let static_url = statics
export let static_url_sprite = '/static'
export let cartBundle = `${static_url}/site/build/js/cart_bundle.js?v=${STATIC_VERSION}`
